export const ROUTES = {
  SUCCESS: 'client/success',
  UNAUTHORIZED: 'client/unauthorized',
  NOT_FOUND: 'client/not-found',
  CLIENT_FORM: (token: string) => `client/forms?token=${token}`,
  LIMS: {
    ROOT: '/lims',
    CREATE: '/lims/new',
    ORDER_DETAILS: (id: string) => `/lims/order/${id}`,
    DIAGNOSTIC_REPORT: (orderId: string, reportId: string) =>
      `/lims/order/${orderId}/diagnostic-report/${reportId}`,
    EDIT_REPORT: (orderId: string) => `/lims/order/${orderId}/edit-report`,
    EDIT_REPORT_EXISTING: (orderId: string, reportId: string) =>
      `/lims/order/${orderId}/edit-report/${reportId}`,
    SAMPLES: '/lims/samples',
  },
};
